import React, { Component } from 'react';
import TruckImage1 from '../Static/classic/P1010019.jpg';
import TruckImage2 from '../Static/classic/IMG_6548.jpg';
import TruckImage3 from '../Static/classic/truck-classic-3.jpg';
import ChangeLocale from "../Components/changeLocale";
import GoBack from "../Components/goBack";
import {FormattedMessage} from "react-intl";

class MuckTruck extends Component {
	render() {
		const { locale, changeLocale } = this.props;

		return (
			<>
				<GoBack />
				<ChangeLocale locale={locale} changeLocale={changeLocale} />
				<h2><FormattedMessage id='muckTruckClassic' /></h2>

				<div className='row justifyContent--center'>
					<div className='gallery-picture-wrap'>
						<img decoding="async" className='gallery-picture' src={TruckImage1} alt='muck-truck-classic' />
						<p>Muck-truck® je dokonalým doplnkom k mini bagru pri menších výkopoch, kde je sťažený prístup pre inú techniku.</p>
					</div>
					<div className='gallery-picture-wrap'>
						<img decoding="async" className='gallery-picture' src={TruckImage2} alt='muck-truck-classic' />
						<p>Muck-truck® sa môže dostať aj do tesných miest, iným strojom neprístupných.</p>
					</div>
					<div className='gallery-picture-wrap'>
						<img decoding="async" className='gallery-picture' src={TruckImage3} alt='muck-truck-classic' />
						<p>Muck-truck® je ideálnym partnerom pri betónovaní. Dokonale funguje spolu  s bubnovými miešačmi na akom akéhokoľvek pracovisku a umožňuje pohodlný odvoz kontrolované vyklápanie betónu betónu.</p>
					</div>
				</div>

				<p>Muck – Truck klasik,  mini-prepravník ktorý odvezie až 250kg nákladu, čo je viac ako trojnásobok čo uvezie bežný fúrik a ešte dokáže stúpať do 30º svahu plne naložený.  Je vysoko odporúčaný z hľadiska zdravia a bezpečnosti, pretože značne zvyšuje produktivitu práce bez výraznej únavy obsluhy.</p>
				<p>Stroje sú vybavené motormi Honda GXV Commercial triedy 5.5hp, ktoré ponúkajú výkonný systém pohonu všetkých štyroch kolies.</p>
				<p>Hnacia náprava Tecumseh má 3 rýchlosti vpred a spiatočku. Je vybavený plynovou pákou, ktorá umožňuje presné riadenie rýchlosti jazdy.</p>
				<p>Vyvážené rozloženie hmotnosti umožňuje ľahké vyklápanie.  Muck- Truck  je vybavený parkovacou brzdou a zastaví sa pri uvoľnenej brzde,  v prípade pádu alebo zakopnutia obsluhy.</p>
			</>
		);
	}
}

// width='363' height='271'

export default MuckTruck;
